import {MatomoInitializerService} from '@ngx-matomo/tracker';
import {Injectable} from '@angular/core';
import {MatomoConfig} from '../../domain/analytics/matomoConfig';
import {IziviaLoggerService} from '../common/iziviaLogger.service';

@Injectable({
    providedIn: 'root'
})
export class MatomoService {

    constructor(private readonly matomoInitializer: MatomoInitializerService,
        private readonly loggerService: IziviaLoggerService) {
    }

    public startMatomo(matomoConfig: MatomoConfig): void {
        if (!matomoConfig || !matomoConfig.siteId || !matomoConfig.trackerUrl) {
            this.loggerService.warning('[Matomo] Invalid configuration', matomoConfig);
            return;
        }

        this.loggerService.debug('[Matomo] Initialize tracker');

        try {
            this.matomoInitializer.initializeTracker(matomoConfig);
        } catch (error) {
            // happens when switching from izivia-ig to izivia (twinning relationship)
            this.loggerService.warning('[Matomo] Initialize tracker failed', error);
        }
    }
}
